import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-battle-gray border-t border-army/30 mt-20">
    <div className="max-w-7xl mx-auto px-4 py-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
        <div>
          <h3 className="text-white font-black text-xl uppercase tracking-tight mb-3">
            VERBAL <span className="text-brand-yellow">WARZONE</span>
          </h3>
          <p className="text-gray-500 text-sm">The premier battle rap video marketplace.</p>
        </div>
        <div>
          <h4 className="text-gray-400 font-semibold text-sm uppercase tracking-wider mb-3">Platform</h4>
          <ul className="space-y-2 text-gray-500 text-sm">
            <li><Link to="/browse" className="hover:text-brand-yellow transition-colors">Browse Battles</Link></li>
            <li><Link to="/profile" className="hover:text-brand-yellow transition-colors">My Profile</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-gray-400 font-semibold text-sm uppercase tracking-wider mb-3">Company</h4>
          <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} Verbal Warzone. All rights reserved.</p>
        </div>
      </div>
      <div className="border-t border-army/20 pt-6 text-center text-gray-600 text-xs">
        Built for the culture.
      </div>
    </div>
  </footer>
);

export default Footer;
